/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Product Metrics API
 * Internal API for publishing product automation metrics.
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions, MutationFunction } from '@tanstack/react-query';
import type { ValidationErrorResponse, ErrorResponse, AutomationUsedRequestBody } from './models';
import { customInstance } from '../core/customInstance';
import type { ErrorType } from '../core/customInstance';

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Publishes an automation_used metric event for the given practice. The caller may optionally provide user_id in the request body; when omitted the backend derives it from the session context. The backend enriches the event with hippospace and timestamp before publishing.

 * @summary Publish an automation-used event
 */
export const publishAutomationUsed = (
  practiceId: number,
  automationUsedRequestBody: AutomationUsedRequestBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/practice/${practiceId}/metrics/automation-used/`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: automationUsedRequestBody,
    },
    options,
  );
};

export const getPublishAutomationUsedMutationOptions = <
  TError = ErrorType<ValidationErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAutomationUsed>>,
    TError,
    { practiceId: number; data: AutomationUsedRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishAutomationUsed>>,
  TError,
  { practiceId: number; data: AutomationUsedRequestBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishAutomationUsed>>,
    { practiceId: number; data: AutomationUsedRequestBody }
  > = (props) => {
    const { practiceId, data } = props ?? {};

    return publishAutomationUsed(practiceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishAutomationUsedMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishAutomationUsed>>
>;
export type PublishAutomationUsedMutationBody = AutomationUsedRequestBody;
export type PublishAutomationUsedMutationError = ErrorType<ValidationErrorResponse | ErrorResponse>;

/**
 * @summary Publish an automation-used event
 */
export const usePublishAutomationUsed = <
  TError = ErrorType<ValidationErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAutomationUsed>>,
    TError,
    { practiceId: number; data: AutomationUsedRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const mutationOptions = getPublishAutomationUsedMutationOptions(options);

  return useMutation(mutationOptions);
};
